import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "antd";
import { useRef } from "react";
import { FormFieldTemplateSuccessorDeletionCheck } from "../successorDeletionCheck.js";
import { FormUntranslatedTemplateNotice } from "../untranslatedTemplateNotice.js";
import { FormValueDifferFromTemplateNotice } from "../valueDifferFromTemplateNotice.js";
import { FormServiceFieldCreateContentBlocker } from "./fields/createContentBlocker.js";
import { FormServiceFieldGeneralCompose } from "./fields/general/compose.js";
import { FormServiceFieldHandlingCompose } from "./fields/handling/compose.js";
import { FormServiceFieldTechnicalCompose } from "./fields/technical/compose.js";
import { FormServiceFieldTemplateCheck } from "./fields/templateCheck.js";
import { useFormService } from "../../../contexts/formService.js";
import { useI18n } from "../../../contexts/i18n.js";
import { useFormInitiallyScrollToField } from "../../../hooks/useFormInitiallyScrollToField.js";
import { FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT, FormValueDifferFromTemplateResetButtonWithConfirm } from "../valueDifferFromTemplateResetButtonWithConfirm.js";
const FormService = ()=>{
    const { __ } = useI18n();
    const ref = useRef();
    const refResetTemplateButton = useRef();
    const { initiallyScrollToField, form } = useFormService();
    useFormInitiallyScrollToField(form, initiallyScrollToField);
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(FormValueDifferFromTemplateNotice, {
                containerRef: ref,
                resetButton: refResetTemplateButton,
                resetButtonEvent: FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT,
                form: "service"
            }),
            /*#__PURE__*/ _jsx(FormUntranslatedTemplateNotice, {
                form: "service"
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralCompose, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldTechnicalCompose, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingCompose, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldCreateContentBlocker, {}),
            /*#__PURE__*/ _jsx(FormFieldTemplateSuccessorDeletionCheck, {
                type: "service"
            }),
            /*#__PURE__*/ _jsxs(Form.Item, {
                className: "rcb-antd-form-sticky-submit",
                colon: false,
                labelAlign: "left",
                label: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateResetButtonWithConfirm, {
                    anchorRef: refResetTemplateButton
                }),
                children: [
                    /*#__PURE__*/ _jsx(FormServiceFieldTemplateCheck, {}),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            textAlign: "center",
                            margin: "10px 0"
                        },
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "submit",
                            className: "button button-primary",
                            value: __("Save")
                        })
                    })
                ]
            })
        ]
    });
};
export { FormService };
